"use strict";
/**
 * Copyright © 2019 - Present, VamStar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const VerticalAlignTopRounded_1 = __importDefault(require("@mui/icons-material/VerticalAlignTopRounded"));
const UnfoldMoreRounded_1 = __importDefault(require("@mui/icons-material/UnfoldMoreRounded"));
const PaginationActions_1 = require("./PaginationActions");
const constants_1 = require("./constants");
const useStyles = makeStyles_1.default((theme) => ({
    root: {
        backgroundColor: theme.palette.black['600'],
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        justifyContent: 'normal',
        zIndex: 1250,
        height: '3.25rem',
    },
    goToTop: {
        lineHeight: '3.25rem',
    },
}));
/**
 * Pagination that always sticks to the bottom of the screen
 * Page number always starts from 1
 * @param props - Pagination props
 * @returns JSX Element
 */
exports.Pagination = (props) => {
    const { count, onPageChange, onPageSizeChange, page, rowsPerPage, loading } = props;
    const classes = useStyles();
    // Scrolls to the top with smooth behaviour
    const goToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (React.createElement("div", { className: classes.root },
        React.createElement(material_1.Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center" },
            React.createElement(material_1.Grid, { item: true, className: classes.goToTop },
                React.createElement(material_1.Button, { size: "large", onClick: goToTop, startIcon: React.createElement(VerticalAlignTopRounded_1.default, null) }, "Top")),
            React.createElement(material_1.Grid, { item: true },
                React.createElement(material_1.TablePagination, { component: "div", count: count, onPageChange: (_e, pageNumber) => onPageChange(pageNumber), page: page - 1, rowsPerPage: rowsPerPage, rowsPerPageOptions: constants_1.COMMON_PAGE_SIZE_OPTIONS, onRowsPerPageChange: event => onPageSizeChange(parseInt(event.target.value, 10)), ActionsComponent: PaginationActions_1.PaginationActions, SelectProps: {
                        variant: 'filled',
                        IconComponent: UnfoldMoreRounded_1.default,
                    }, hidden: loading })))));
};
//# sourceMappingURL=data:application/json;base64,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